var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { useBreakpoints, Styler, Button, ControlIcon, TypographyBody, Skeleton, Notification, Avatar, useDisclosure, Dialog, DialogContent, DialogFooter, DialogHeader, } from '@honeycomb/ui-core';
import { interjectResourceString } from '../../utils/interjectResourceString';
import { pluraliseCount } from '../../utils/pluraliseCount';
import { useAppliedFiltersCount } from './useAppliedFiltersCount';
/**
 * @deprecated `FiltersModal` is depreacted. Please the seperate `FiltersDialog` and `FiltersButton` components.
 */
export function FiltersModal(_a) {
    var { children, loading, filteredDataCount = 0, product } = _a, other = __rest(_a, ["children", "loading", "filteredDataCount", "product"]);
    const { resourceStrings: { SRP_FILTERBUTTON_LABEL, MODAL_FILTER_RESULTS_TITLE, NORESULTS_MATCHING_FILTERS_MAIN, NORESULTS_MATCHING_FILTERS_FLIGHTS_SUB, FILTERS_DIALOG_BUTTON_LABEL, FILTERS_DIALOG_BUTTON_LABEL_SINGLUAR, FILTERS_DIALOG_BUTTON_LABEL_LOADING, }, } = useGlobalContext();
    const [dialogOpen, { open: handleOpenDialog, close: handleCloseDialog }] = useDisclosure(false);
    const [dialogExited, setDialogExited] = React.useState(true);
    const { mediumUp } = useBreakpoints();
    const appliedFiltersCount = useAppliedFiltersCount(product);
    const getButtonLabel = useCallback(() => {
        if (loading) {
            return FILTERS_DIALOG_BUTTON_LABEL_LOADING;
        }
        return pluraliseCount(filteredDataCount, {
            singular: FILTERS_DIALOG_BUTTON_LABEL_SINGLUAR,
            plural: interjectResourceString(FILTERS_DIALOG_BUTTON_LABEL, filteredDataCount),
        });
    }, [
        FILTERS_DIALOG_BUTTON_LABEL,
        FILTERS_DIALOG_BUTTON_LABEL_LOADING,
        FILTERS_DIALOG_BUTTON_LABEL_SINGLUAR,
        filteredDataCount,
        loading,
    ]);
    return (React.createElement(React.Fragment, null,
        loading ? (React.createElement(Skeleton, { radius: 10 },
            React.createElement(Button, { w: 120 }, SRP_FILTERBUTTON_LABEL))) : (React.createElement(Button, { "data-id": "filter", onClick: () => {
                handleOpenDialog();
                setDialogExited(false);
            }, color: "primary", icon: React.createElement(ControlIcon, null), decoration: appliedFiltersCount ? (React.createElement(Avatar, { color: "common.white", textColor: "primary.base" }, appliedFiltersCount)) : undefined, pr: appliedFiltersCount > 0 ? 3 : undefined }, SRP_FILTERBUTTON_LABEL)),
        (dialogOpen || !dialogExited) && (React.createElement(Dialog, Object.assign({ position: mediumUp ? 'drawer-left' : 'centered', size: "m", fullScreen: "mobile-only", open: dialogOpen, onClose: handleCloseDialog, onExited: () => setDialogExited(true) }, other),
            React.createElement(DialogHeader, { withCloseButton: true }, MODAL_FILTER_RESULTS_TITLE),
            React.createElement(DialogContent, { bg: "background.offset" },
                React.createElement(Styler, { py: 4 },
                    !loading && filteredDataCount === 0 && (React.createElement(Notification, { color: "info", variant: "compact", mb: 5 },
                        React.createElement(TypographyBody, { weight: "bold", "data-id": "no-results-text" }, NORESULTS_MATCHING_FILTERS_MAIN),
                        React.createElement("p", { "data-id": "no-results-sub-text" }, NORESULTS_MATCHING_FILTERS_FLIGHTS_SUB))),
                    children)),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { "data-id": "view-matches", color: "callToAction", size: "l", fullWidth: true, disabled: !filteredDataCount, onClick: () => {
                        handleCloseDialog();
                        setDialogExited(true);
                    }, loading: loading }, getButtonLabel()))))));
}
